export const REQUEST_FAILED = 'INFO_CHANNELS_REQUEST_FAILED';
export const LIST = 'INFO_CHANNELS_LIST';
export const LIST_SUCCEEDED = 'INFO_CHANNELS_LIST_SUCCEEDED';
export const REMOVE = 'INFO_CHANNEL_REMOVE';
export const REMOVE_SUCCEEDED = 'INFO_CHANNEL_REMOVE_SUCCEEDED';
export const CREATE = 'INFO_CHANNEL_CREATE';
export const CREATE_SUCCEEDED = 'INFO_CHANNEL_CREATE_SUCCEEDED';
